import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * <variant-title> — re-renders its contents from the freshly fetched section
 * HTML whenever a `variant:update` event fires. Uses the same morph pipeline
 * as product-inventory / product-form so liquid stays the single source of
 * truth for what the title looks like (prefix, typography, etc.).
 */
class VariantTitle extends HTMLElement {
  #section;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(ThemeEvents.variantUpdate, this.#update);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(ThemeEvents.variantUpdate, this.#update);
  }

  #update = (event) => {
    // Ignore events from a different product (combined listings, quick-add, etc.)
    if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId &&
      this.dataset.productId &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newHtml = event.detail?.data?.html;
    if (!newHtml) return;

    const selector = this.dataset.productId
      ? `variant-title[data-product-id="${this.dataset.productId}"]`
      : 'variant-title';
    const next = newHtml.querySelector(selector);
    if (!next) return;

    morph(this, next, { childrenOnly: true });
  };
}

if (!customElements.get('variant-title')) {
  customElements.define('variant-title', VariantTitle);
}
